/* eslint semi: 1, react/prop-types:1, no-shadow:0, no-alert:0 */

import React from 'react';
import PropTypes from 'prop-types';
import request from 'superagent';
import { connect } from 'react-redux';
import { addBuilds, toggleAvailableBuilds } from '../actions/app-actions';

const BuildButton = ({ platform, version, link }) => {

    let formattedPlatform;

    if(platform === 'macos64') {
        formattedPlatform = '64 bit macOS';
    } else if(platform === 'windows64') {
        formattedPlatform = '64 bit Windows';
    } else if(platform === 'windows32') {
        formattedPlatform = '32 bit Windows';
    } else if(platform === 'linux64') {
        formattedPlatform = '64 bit Linux';
    }

    const styles = {
        downloadButton: {
            textAlign: 'center',
            width: '100%',
            whiteSpace: 'pre-line',
            fontWeight: 'bold'
        }
    };

    return (
        <a href={link} className="btn btn-primary" style={styles.downloadButton}>
            {`Download\nv${version}\n${formattedPlatform}`}
        </a>
    );
};
BuildButton.propTypes = {
    platform: PropTypes.string,
    version: PropTypes.string,
    link: PropTypes.string
};

const sortByVersion = arr => {
    return arr
        .concat()
        .sort((a, b) => {

            const versionA = a.version;
            const versionB = b.version;

            const splitA = versionA
                .split('.')
                .map(n => parseInt(n, 10));
            const splitB = versionB
                .split('.')
                .map(n => parseInt(n, 10));

            const [ majorA, minorA, patchA ] = splitA;
            const [ majorB, minorB, patchB ] = splitB;

            if(majorA === majorB) {

                if(minorA === minorB) {

                    if(patchA === patchB) {
                        return 0;
                    } else {
                        return patchA > patchB ? 1 : -1;
                    }

                } else {
                    return minorA > minorB ? 1 : -1;
                }

            } else {
                return majorA > majorB ? 1 : -1;
            }

        });
};

const DownloadButtonGroup = ({ builds }) => {

    const reverseBuilds = builds
        .concat()
        .reverse();

    const macosBuild = reverseBuilds.find(b => b.platform === 'macos64');
    const macosButton = macosBuild ?
        <BuildButton platform={macosBuild.platform} version={macosBuild.version} link={macosBuild.link} />
        :
        '';

    const win64Build = reverseBuilds.find(b => b.platform === 'windows64');
    const win64Button = win64Build ?
        <BuildButton platform={win64Build.platform} version={win64Build.version} link={win64Build.link} />
        :
        '';

    const win32Build = reverseBuilds.find(b => b.platform === 'windows32');
    const win32Button = win32Build ?
        <BuildButton platform={win32Build.platform} version={win32Build.version} link={win32Build.link} />
        :
        '';

    const linux64Build = reverseBuilds.find(b => b.platform === 'linux64');
    const linux64Button = linux64Build ?
        <BuildButton platform={linux64Build.platform} version={linux64Build.version} link={linux64Build.link} />
        :
        '';

    return (
        <div className="row">
            <div className="col-md-4">
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h3 className="panel-title"><i className="fa fa-windows" aria-hidden="true"></i> Windows</h3>
                    </div>
                    <div className="panel-body">
                        <div className="form-group">
                            {win32Button}
                        </div>
                        <div className="form-group">
                            {win64Button}
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h3 className="panel-title"><i className="fa fa-apple" aria-hidden="true"></i> macOS</h3>
                    </div>
                    <div className="panel-body">
                        <div className="form-group">
                            {macosButton}
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h3 className="panel-title"><i className="fa fa-linux" aria-hidden="true"></i> Linux (Debian/Ubuntu)</h3>
                    </div>
                    <div className="panel-body">
                        {
                            !linux64Build ?
                            <div className="form-group">
                                <p className="text-danger">There are no builds to display.</p>
                            </div>
                            :
                            <div>
                                <div className="form-group">
                                    {linux64Button}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};
DownloadButtonGroup.propTypes = {
    builds: PropTypes.arrayOf(PropTypes.object)
};

class Downloads extends React.Component {

    componentDidMount() {

        const { addBuilds } = this.props;

        const foundObj = {};

        request
            .get('/builds')
            // .get('http://localhost:3300/builds')
            .end((err, res) => {
                if(err) {
                    console.error(err);
                    alert('There was an error loading the builds. Please contact help@literacystarter.com if the problem persists.');
                    return;
                }
                const builds = JSON.parse(res.text);
                const sortedBuilds = sortByVersion(builds)
                    .reverse()
                    .filter(b => {
                        const escapedLink = JSON.stringify(b.link);
                        if(!foundObj[escapedLink]) {
                            foundObj[escapedLink] = 1;
                            return true;
                        } else {
                            return false;
                        }
                    })
                    .reverse();
                addBuilds(sortedBuilds);
            });
    }

    render() {

        const { builds, showAvailableBuilds, toggleAvailableBuilds } = this.props;

        const literacyStarterBuilds = builds
            .filter(b => b.type === 'literacy-starter');

        const LiteracyStarterBuildButtons = <DownloadButtonGroup builds={literacyStarterBuilds} />;

        const preLiteracyBuilds = builds
            .filter(b => b.type === 'pre-literacy');

        const PreLiteracyBuildButtons = <DownloadButtonGroup builds={preLiteracyBuilds} />;

        const teachersGuideBuilds = builds
            .filter(b => b.type === 'teachers-guide');

        const TeachersGuideBuildButtons = <DownloadButtonGroup builds={teachersGuideBuilds} />;

        const imageFinderBuilds = builds
            .filter(b => b.type === 'image-finder');

        const ImageFinderBuildButtons = <DownloadButtonGroup builds={imageFinderBuilds} />;

        const buildsTableRows = builds
            .concat()
            .sort((a, b) => a.date === b.date ? 0 : a.date > b.date ? -1 : 1)
            .map(b => (
                <tr key={b.link}>
                    <td>{b.type === 'literacy-starter' ? 'Literacy Starter' : b.type === 'pre-literacy' ? 'Pre-Literacy' : b.type === 'teachers-guide' ? 'Teacher\'s Guide' : 'Image Finder'}</td>
                    <td>{b.version}</td>
                    <td>{b.platform}</td>
                    <td><a href={b.link}><i className="fa fa-download"></i> Download</a></td>
                </tr>
            ));

        const buildsTable = showAvailableBuilds ?
            <table className="table table-hover">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Version</th>
                        <th>Platform</th>
                        <th>Link</th>
                    </tr>
                </thead>
                <tbody>
                    {buildsTableRows}
                </tbody>
            </table>
            :
            '';

        const styles = {
            nameHeader: {
                marginTop: 0,
                marginBottom: 20
            },
            warning: {
                marginBottom: 20,
            }
        };

        return (
            <div>
                <div className="page-header">
                    <h1>Downloads</h1>
                </div>

                <div className="row">

                    <div className="col-md-6 col-sm-12">
                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <h3 className="panel-title">Fonts</h3>
                            </div>
                            <div className="panel-body">
                                <p className="text-info">These applications require certain fonts if you are working with a Roman script language. Please download and install the following fonts to your system before installing Literacy Starter or Pre-Literacy.</p>
                                <div>
                                    <a href="https://software.sil.org/downloads/r/andika/Andika-5.000.zip" style={{minWidth: 100, marginLeft: 10, marginRight: 10}} className="btn btn-primary"><i className="fa fa-download"></i> Andika 5000</a>
                                    <a href="https://s3.amazonaws.com/com.literacystarter.data/Alit.zip" style={{minWidth: 100, marginLeft: 10, marginRight: 10}} className="btn btn-primary"><i className="fa fa-download"></i> Alit family</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-sm-12">
                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <h3 className="panel-title">LibreOffice</h3>
                            </div>
                            <div className="panel-body">
                                <p className="text-info">All booklets are exported into file types which can be opened with LibreOffice (an office suite comparable to Microsoft Office). In order to open your exported booklets you will need LibreOffice installed. You can download it from the link below. We recommend the mature version which is the most stable.</p>
                                <div>
                                    <a href="https://www.libreoffice.org/download/download/" target="_blank" style={{minWidth: 100, marginLeft: 10, marginRight: 10}} className="btn btn-primary"><i className="fa fa-download"></i> LibreOffice Downloads</a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="row">
                    <div className="col-sm-12">
                        <h2 style={styles.nameHeader}>Literacy Starter</h2>
                        <p className="text-info">This software is free to download but requires an activation code in order to use. Because this software is still under development, activation codes are only being handed out to approved testers.</p>
                    </div>
                </div>

                {LiteracyStarterBuildButtons}

                <div className="row">
                    <div className="col-sm-12">
                        <h2 style={styles.nameHeader}>{'Pre-Literacy'}</h2>
                        <p className="text-info">Pre-Literacy is accompaniment software for Literacy Starter and cannot be used on its own.</p>
                    </div>
                </div>

                {PreLiteracyBuildButtons}

                <div className="row">
                    <div className="col-sm-12">
                        <h2 style={styles.nameHeader}>{'Teacher\'s Guide'}</h2>
                        <p className="text-info">The Teacher's Guide generator is accompaniment software for Literacy Starter and cannot be used on its own.</p>
                    </div>
                </div>

                {TeachersGuideBuildButtons}

                <div className="row">
                    <div className="col-sm-12">
                        <h2 style={styles.nameHeader}>{'Image Finder'}</h2>
                        <p className="text-info">Image Finder is intended for use with Literacy Starter but may be used on its own as well.</p>
                    </div>
                </div>

                <h3 style={styles.warning}><strong className="text-danger">Once images are loaded, Image Finder will require 2.5 GB on your hard drive.</strong></h3>
                {ImageFinderBuildButtons}

                <div className="row">
                    <div className="col-xs-12">
                        {
                            showAvailableBuilds ?
                            <p style={{textAlign: 'center'}}><a href="#" onClick={toggleAvailableBuilds}><i className="fa fa-chevron-up"></i> Hide All Available Builds</a></p>
                            :
                            <p style={{textAlign: 'center'}}><a href="#" onClick={toggleAvailableBuilds}><i className="fa fa-chevron-down"></i> Show All Available Builds</a></p>
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-offset-2 col-md-8">
                        {buildsTable}
                    </div>
                </div>
            </div>
        );
    }

}

Downloads.propTypes = {
    builds: PropTypes.arrayOf(PropTypes.object),
    showAvailableBuilds: PropTypes.bool,
    addBuilds: PropTypes.func,
    toggleAvailableBuilds: PropTypes.func
};

const DownloadsContainer = connect(
    state => {
        const { appState } = state;
        return {
            builds: appState.builds,
            showAvailableBuilds: appState.showAvailableBuilds
        };
    },
    dispatch => {
        return {
            addBuilds: builds => dispatch(addBuilds(builds)),
            toggleAvailableBuilds(e) {
                e.preventDefault();
                dispatch(toggleAvailableBuilds());
            }
        };
    }
)(Downloads);

export default DownloadsContainer;



/** WEBPACK FOOTER **
 ** ./src/components/download.js
 **/